/**
 * Localizador de tiendas — Apodemia
 * Leaflet + markercluster (autohospedados) + tiles CARTO/OSM (sin API key).
 * Lee las tiendas del <script data-stores-json> (migradas de ProMap), pinta los
 * marcadores agrupados, enlaza las tarjetas SSR (buscar + "Ver en el mapa") y
 * en móvil alterna LISTADO / MAPA.
 */
(function () {
  'use strict';

  var TILES = {
    voyager: {
      url: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',
      attr: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>',
      sub: 'abcd', maxZoom: 20
    },
    positron: {
      url: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png',
      attr: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>',
      sub: 'abcd', maxZoom: 20
    },
    osm: {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attr: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      sub: 'abc', maxZoom: 19
    }
  };

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  // Espera a que Leaflet (defer) esté disponible.
  function whenLeaflet(fn, tries) {
    tries = tries || 0;
    if (window.L && window.L.markerClusterGroup) return fn();
    if (tries > 100) return; // ~10s
    setTimeout(function () { whenLeaflet(fn, tries + 1); }, 100);
  }

  function init(root) {
    var mapEl = root.querySelector('[data-stores-map]');
    var jsonEl = root.querySelector('[data-stores-json]');
    if (!mapEl || !jsonEl) return;

    var stores = [];
    try { stores = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-store-card]'));
    var searchEl = root.querySelector('[data-stores-search]');
    var emptyEl = root.querySelector('[data-stores-empty]');

    var tileKey = root.getAttribute('data-tiles') || 'voyager';
    var tile = TILES[tileKey] || TILES.voyager;

    var map = L.map(mapEl, {
      scrollWheelZoom: false,
      zoomControl: true,
      attributionControl: true
    }).setView(
      [parseFloat(root.getAttribute('data-center-lat')) || 40, parseFloat(root.getAttribute('data-center-lng')) || -3],
      parseInt(root.getAttribute('data-zoom'), 10) || 5
    );
    L.tileLayer(tile.url, { attribution: tile.attr, subdomains: tile.sub, maxZoom: tile.maxZoom }).addTo(map);
    map.on('click', function () { map.scrollWheelZoom.enable(); });

    // Marcador de gota (SVG) en el verde de la marca.
    var accent = getComputedStyle(root).getPropertyValue('--stores-accent').trim() || '#858B6E';
    function pinIcon() {
      return L.divIcon({
        className: 'apodemia-stores__marker',
        html: '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="36" viewBox="0 0 28 36"><path d="M14 0C6.27 0 0 6.27 0 14c0 9.5 14 22 14 22s14-12.5 14-22C28 6.27 21.73 0 14 0Z" fill="' + accent + '"/><circle cx="14" cy="14" r="5" fill="#fff"/></svg>',
        iconSize: [28, 36], iconAnchor: [14, 36], popupAnchor: [0, -34]
      });
    }

    var cluster = L.markerClusterGroup({
      showCoverageOnHover: false,
      maxClusterRadius: 45,
      iconCreateFunction: function (c) {
        return L.divIcon({
          className: 'apodemia-stores__cluster',
          html: '<span>' + c.getChildCount() + '</span>',
          iconSize: [40, 40]
        });
      }
    });

    var markers = {};
    stores.forEach(function (st) {
      if (typeof st.lat !== 'number' || typeof st.lng !== 'number') return;
      var m = L.marker([st.lat, st.lng], { icon: pinIcon() });
      var html = '<strong>' + esc(st.title) + '</strong><br>' + esc(st.addr);
      if (st.phone) html += '<br><a href="tel:' + esc(st.phone.replace(/\s/g, '')) + '">' + esc(st.phone) + '</a>';
      if (st.hours) {
        html += '<div class="apodemia-stores__popup-hours">' + esc(st.hours).replace(/\n/g, '<br>') + '</div>';
      }
      var mapsUrl = st.maps || ('https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(st.title + ' ' + st.addr));
      html += '<a class="apodemia-stores__popup-maps" target="_blank" rel="noopener" href="' + esc(mapsUrl) + '">' + (root.getAttribute('data-open-maps-label') || 'Abrir en Maps') + '</a>';
      m.bindPopup(html, { className: 'apodemia-stores__popup', maxWidth: 280 });
      cluster.addLayer(m);
      markers[st.i] = m;
    });
    map.addLayer(cluster);

    // Encaja el mapa a todos los marcadores. Guardamos los bounds para re-encajar
    // cuando el mapa se hace visible (en móvil el panel arranca oculto → 0px → el
    // fitBounds inicial salía "en medio del mar" con zoom raro).
    var storeBounds = null;
    function fitStores() {
      if (!storeBounds) return;
      try { map.fitBounds(storeBounds, { padding: [40, 40], maxZoom: 7 }); } catch (e) {}
    }
    try {
      var b = cluster.getBounds();
      if (b.isValid()) { storeBounds = b; fitStores(); }
    } catch (e) {}

    // "Ver en el mapa" → centra el marcador (y abre su popup / cambia a MAPA en móvil).
    function focus(index) {
      var m = markers[index];
      if (!m) return;
      if (window.matchMedia('(max-width: 989px)').matches) showTab('map');
      map.invalidateSize();
      var ll = m.getLatLng();
      cluster.zoomToShowLayer(m, function () {
        map.setView(ll, Math.max(map.getZoom(), 15), { animate: true });
        m.openPopup();
      });
    }
    cards.forEach(function (card) {
      var btn = card.querySelector('[data-store-focus]');
      if (btn) btn.addEventListener('click', function () { focus(parseInt(btn.getAttribute('data-store-focus'), 10)); });
    });

    // Buscar: filtra las tarjetas por texto.
    if (searchEl) {
      searchEl.addEventListener('input', function () {
        var q = searchEl.value.trim().toLowerCase();
        var shown = 0;
        cards.forEach(function (card) {
          var hit = !q || (card.getAttribute('data-search') || '').indexOf(q) !== -1;
          card.hidden = !hit;
          if (hit) shown++;
        });
        if (emptyEl) emptyEl.hidden = shown !== 0;
      });
    }

    // Tabs (móvil): LISTADO / MAPA.
    function showTab(which) {
      root.querySelectorAll('[data-stores-tab]').forEach(function (t) {
        var on = t.getAttribute('data-stores-tab') === which;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      root.querySelectorAll('[data-stores-panel]').forEach(function (p) {
        p.classList.toggle('is-visible', p.getAttribute('data-stores-panel') === which);
      });
      if (which === 'map') setTimeout(function () { map.invalidateSize(); fitStores(); }, 60);
    }
    root.querySelectorAll('[data-stores-tab]').forEach(function (t) {
      t.addEventListener('click', function () { showTab(t.getAttribute('data-stores-tab')); });
    });

    // En móvil los paneles arrancan ocultos (solo se ven con .is-visible, que ponía
    // showTab). Activamos el panel de la pestaña por defecto (LISTADO) en init para
    // que el listado NO salga vacío en la primera carga. En escritorio es inocuo
    // (ambos paneles se muestran siempre por CSS).
    var activeTab = root.querySelector('[data-stores-tab].is-active');
    showTab(activeTab ? activeTab.getAttribute('data-stores-tab') : 'list');

    // Preselección por ?tienda= (p. ej. desde la página de Eventos): enfoca esa
    // tienda (en móvil pasa a MAPA y abre su popup; en escritorio la centra).
    try {
      var wanted = new URLSearchParams(window.location.search).get('tienda');
      if (wanted) {
        var slug = wanted.trim().toLowerCase();
        var foundIdx = -1;
        stores.forEach(function (st, i) {
          var n = ((st.title || '') + ' ' + (st.addr || '')).toLowerCase();
          if (foundIdx === -1 && n.indexOf(slug) !== -1) foundIdx = i;
        });
        if (foundIdx !== -1) setTimeout(function () { focus(foundIdx); }, 350);
      }
    } catch (e) {}

    // Corrige el tamaño del mapa una vez pintado (columnas flex) y re-encaja.
    setTimeout(function () { map.invalidateSize(); fitStores(); }, 200);
    window.addEventListener('resize', function () { map.invalidateSize(); });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  ready(function () {
    var root = document.querySelector('[data-store-locator]');
    if (root) whenLeaflet(function () { init(root); });
  });
})();
